import {
    Form, Modal, Input, Tooltip, Space, Typography, notification,
    Select,
} from 'antd';
import { useContext, useState } from 'react';
import { BsLightbulb } from 'react-icons/bs';
import { addTransaction } from '../../../api/dispersions';
import { IDispersion } from '../../../interfaces/dispersion.interface';
import { DispersionContext } from '../../DispersionDetail/context/dispersionContext';

const { TextArea } = Input;
const { Text } = Typography;

interface IProps {
    dispersion: IDispersion
    visible: boolean;
    onCancel: () => void;
}

export const NewTransaction = ({
    visible, onCancel, dispersion,
}: IProps) => {
    const { fetchDispersion } = useContext(DispersionContext);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const selectedType = Form.useWatch('type', form);

    const types = [
        {
            value: 'CASH',
            label: 'Cash',
        },
        {
            value: 'L2P',
            label: 'Link to pay',
        },
    ];

    const onFinish = (values: any) => {
        setLoading(true);
        const payload = {
            ...values,
        };

        values.type !== 'L2P' && delete payload.paymentIntent;

        addTransaction(dispersion._id, payload)
            .then(() => {
                notification.success({
                    message: 'Transaction added successfully',
                });
                fetchDispersion();
            })
            .catch((error) => {
                const description = error.response?.data?.message;
                notification.error({
                    message: 'Error adding transaction',
                    description,
                });
            })
            .finally(() => {
                setLoading(false);
                form.resetFields();
                onCancel();
            });
    };

    const RULES = [
        {
            required: true,
            message: 'Please input amount!',
        },
    ];

    return (
        <Modal
            open={visible}
            title={`Add transaction - Dispersion ${dispersion.dispersionUniqueID}`}
            onCancel={onCancel}
            onOk={() => form.submit()}
            okText="Add"
            confirmLoading={loading}
        >
            <Space direction="vertical" size={24}>
                <Space direction="horizontal" size={8}>
                    <BsLightbulb color="#FFF" size={14} />
                    <Text>
                        Recuerda ser claro en tus comentarios, ya que facilitará la comprensión en futuras referencias.
                    </Text>
                </Space>

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{
                        currency: dispersion.currency,
                    }}
                >
                    <Form.Item hidden name="currency">
                        <Input />
                    </Form.Item>

                    <Form.Item name="bookingID" label="Booking">
                        <Input />
                    </Form.Item>

                    <Form.Item name="type" label="Type">
                        <Select options={types} defaultValue={types[0].value} />
                    </Form.Item>

                    {selectedType === 'L2P' && (
                        <Form.Item
                            name="paymentIntent"
                            label="Payment Intent"
                            rules={[{ required: true, message: 'Payment Intent es requerido para L2P' }]}
                        >
                            <Input />
                        </Form.Item>
                    )}

                    <Form.Item
                        name="amount"
                        label="Amount"
                        rules={RULES}
                    >
                        <Input type="number" />
                    </Form.Item>

                    <Form.Item
                        name="comment"
                        label="Comment"
                    >
                        <TextArea rows={4} />
                    </Form.Item>
                </Form>
            </Space>
        </Modal>
    );
};
